var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#005C99",
    strokeWidth: 1.872
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.099 24.972h-25.6c-.863 0-1.563-.7-1.563-1.564V5.5c0-.864.7-1.564 1.564-1.564h25.599c.863 0 1.563.7 1.563 1.564v17.908c0 .864-.7 1.564-1.563 1.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.313 27.955h13.971"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005C99",
    d: "M13.223 8c2.884 0 5.222 2.355 5.222 5.261 0 .903-.226 1.753-.623 2.495l2.805 2.372c.412.348.491.944.203 1.385l-.073.099c-.35.413-.941.49-1.375.202l-.098-.074-2.801-2.369a5.177 5.177 0 0 1-3.26 1.151c-2.885 0-5.223-2.355-5.223-5.26C8 10.354 10.338 8 13.223 8Zm.027 1.75a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearch);
export default ForwardRef;